'use strict'

import { AcrossLite } from './lib/across_lite.js'
import { Jpz } from './lib/jpz.js'
import { PaJson } from './lib/pa_json.js'
import { PzlJson } from './lib/pzl_json.js'
import { PzlSvg } from './lib/pzl_svg.js'

export { AcrossLite } from './lib/across_lite.js'
export { Cell } from './lib/cell.js'
export { Clue } from './lib/clue.js'
export { Jpz } from './lib/jpz.js'
export { PaJson } from './lib/pa_json.js'
export { PzlSvg } from './lib/pzl_svg.js'

// These should probably be migrated to a separate package.
export {
  convertBuffer, cssClassify, dasherize,
  detectFile, detectFiletypeFromName
} from './lib/helpers.js'

export class PzlTools {
  constructor ({
    exportSvgFileId = undefined,
    importFileId = 'file',
    svgSelector = '.player svg'
  } = {}) {
    this.importFileId = importFileId
    this.exportSvgFileId = exportSvgFileId
    this.svgSelector = svgSelector

    this._addEvents()
  }

  _addEvents () {
    this._addFileImportEvents()

    if (this.exportSvgFileId) {
      this._addFileExportEvents()
    }
  }

  // @todo This should be moved to a separate package.
  _addFileImportEvents () {
    let f = document.getElementById(this.importFileId)

    if (f) {
      let _this = this
      f.addEventListener('change', (e) => {
        // Only get the first file.
        const file = e.srcElement.files[0]
        if (!file) {
          return
        }

        let reader = new FileReader()

        reader.onloadend = function (e) {
          let buf = e.target.result

          _this.importPuzzleByBuffer(buf, file.name)
        }

        reader.readAsArrayBuffer(file)
      })
    }
  }

  importPuzzleByStr (str, fn) {
    var buf = new ArrayBuffer(str.length)
    var bufView = new Uint8Array(buf)

    for (let i = 0, strLen = str.length; i < strLen; i++) {
      bufView[i] = str.charCodeAt(i)
    }

    return this.importPuzzleByBuffer(
      buf, fn
    )
  }

  importPuzzleByBuffer (buf, fn) {
    let dataview = new DataView(buf)
    let bufLen = buf.byteLength
    let byteArray = new Uint8Array(bufLen)

    for (let i = 0; i < bufLen; i++) {
      byteArray[i] = dataview.getUint8(i).toString(10)
    }

    let XW
    switch (this._detectFiletypeFromName(fn)) {
      case 'jpz':
        XW = new Jpz()
        break
      case 'pa_json':
        XW = new PaJson()
        break
      case 'json':
        XW = new PzlJson()
        break
      case 'pzl_json':
        XW = new PzlJson()
        break
      case 'pzl_svg':
        XW = new PzlSvg()
        break
      default:
        XW = new AcrossLite()
    }

    return XW.importPuzzle(byteArray)
  }

  _detectFiletypeFromName (fn) {
    let filetype = 'across_lite'
    let ext = fn.match(/.(\w+)$/)[1].toLowerCase()

    switch (ext) {
      case 'jpz':
        filetype = 'jpz'
        break
      case 'js':
        filetype = 'pa_json'
        break
      case 'json':
        filetype = 'pzl_json'
        break
      case 'pzl':
        filetype = 'pzl_json'
        break
      case 'svg':
        filetype = 'pzl_svg'
        break
    }

    return filetype
  }

  _addFileExportEvents () {
    document.getElementById(
      this.exportSvgFileId
    ).addEventListener('click', this.exportSvg)
  }

  exportSvg () {
    const svgHtml = document.getElementsByTagName('svg')[0].outerHTML

    let blob = new Blob([
      unescape(svgHtml)
    ], {
      type: 'application/svg+xml'
    })

    let link = document.createElement('a')
    link.href = window.URL.createObjectURL(blob)
    link.download = 'pzl.svg'
    link.click()
  }
}



//////////////////
// WEBPACK FOOTER
// ./~/pzl-tools/index.js
// module id = 906
// module chunks = 0